// Hook gói toàn bộ logic của màn Tạo/Xem/Phê duyệt tờ trình V2.
// Tách khỏi phần render để component chỉ còn JSX (UI giữ nguyên như V1).
import { useEffect, useState, useCallback, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { trinhKyApi } from "../services/trinhKyApi";
import { ACTION, STATUS, ROUTE, groupStepsByPosition } from "../constants/trinhKy";
import { checkRole } from "../../model";

const DEFAULT_DETAIL = {
  title: "",
  workflow_type: 0,
  code: "",
  code_file: "",
  status: 1,
  position: 1,
  list_file: [],
};

export default function useTrinhKy(id) {
  const { user } = useSelector((state) => state.auth);
  const { saveWorkfollow } = useSelector((state) => state.save);
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(false);
  const [detail, setDetail] = useState(null);
  const [listLoaiToTrinh, setListLoaiToTrinh] = useState([]);
  const [workfollowId, setWorkfollowId] = useState(null);
  const [reloadProgress, setReloadProgress] = useState(false);
  const [listProgress, setListProgress] = useState([]);
  const [userComment, setUserComment] = useState("");
  const [myMessage, setMyMessage] = useState("");
  const [listMessage, setListMessage] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [dataNewMember, setDataNewMember] = useState(null);
  const [modalAddMember, setModalAddMember] = useState(false);
  const [tempUser, setTempUser] = useState({});
  const [resetKey, setResetKey] = useState(0);
  const [canCancle, setCanCancle] = useState(false);

  const [usersSuggest, setUsersSuggest] = useState([]);
  const [showSuggest, setShowSuggest] = useState(false);
  const [tagKeyword, setTagKeyword] = useState("");
  const inputRef = useRef(null);

  const roleCancle = checkRole(user, "workflow_walking", "cancle");

  // ---- Fetch ----
  const fetchMessage = useCallback(() => {
    trinhKyApi
      .listMessages(user.config, id)
      .then((res) => {
        if (res.data.status === "success") setListMessage(res.data.data);
      })
      .catch((e) => console.log(e));
  }, [user.config, id]);

  const checkRoleCancle = useCallback(
    (listItem = [], dataif) => {
      const hasReturn = listItem.some((item) => item.action == ACTION.RETURN);
      if (dataif && dataif.author_id == user.data.id && hasReturn && dataif.status == STATUS.RUNNING) {
        setCanCancle(true);
      }
    },
    [user.data.id]
  );

  const fetchDetail = useCallback(
    (reload = true) => {
      if (reload) setPageLoading(true);
      trinhKyApi
        .getDetail(user.config, id)
        .then((res) => {
          setPageLoading(false);
          if (res.data.status === "success") {
            const dataif = res.data.data || {};
            // ID cũ đã được đánh số lại -> chuyển hướng sang URL id mới.
            if (dataif.redirect_id) {
              history.replace(ROUTE.edit(dataif.redirect_id));
              return;
            }
            dataif.list_file = dataif.list_file && JSON.parse(dataif.list_file);
            dataif.file_attachments = dataif.file_attachments && JSON.parse(dataif.file_attachments);
            dataif.file_signed = dataif.file_signed && JSON.parse(dataif.file_signed);
            checkRoleCancle(dataif?.workflow_steps_json || [], dataif);
            dataif.groupedList = groupStepsByPosition(dataif?.workflow_steps_json || []);
            setDetail(dataif);
            if (dataif.workflow_type) setWorkfollowId(dataif.workflow_type);
          }
        })
        .catch((e) => {
          console.log(e);
          setPageLoading(false);
        });
    },
    [user.config, id, checkRoleCancle]
  );

  const fetchSteps = useCallback(() => {
    if (!id || id == 0) {
      if (!workfollowId) {
        setListProgress([]);
        return;
      }
      setReloadProgress(true);
      trinhKyApi
        .stepsTemplate(user.config, workfollowId)
        .then((res) => {
          setReloadProgress(false);
          if (res.data.status === "success") {
            const data = (res.data.data || []).map((step) => {
              const copied = { ...step };
              copied.list_progress = Array.isArray(step.list_progress)
                ? step.list_progress.map((p) => ({ ...p }))
                : [];
              return copied;
            });
            setListProgress(data);
          } else {
            console.log("Fetch steps error:", res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setReloadProgress(false);
        });
    }
  }, [workfollowId, id, user.config]);

  // ---- Effects ----
  useEffect(() => {
    let mounted = true;
    trinhKyApi
      .listTypes(user.config)
      .then((res) => {
        if (!mounted) return;
        if (res.data.status === "success") setListLoaiToTrinh(res.data.data || []);
      })
      .catch((e) => console.log(e));

    if (id > 0) {
      fetchMessage();
      fetchDetail();
    }
    return () => {
      mounted = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, id]);

  useEffect(() => {
    if (detail && listLoaiToTrinh.length > 0) setWorkfollowId(Number(detail.workflow_type));
  }, [detail, listLoaiToTrinh]);

  // Realtime: socket -> redux saveWorkfollow.
  useEffect(() => {
    if (id > 0 && detail && saveWorkfollow) {
      if (saveWorkfollow.workfollow_id == detail.id) {
        if (saveWorkfollow.node_type === "message") fetchMessage();
        if (saveWorkfollow.node_type === "workfollow") {
          fetchDetail(false);
          fetchMessage();
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveWorkfollow, id]);

  useEffect(() => {
    if (workfollowId != 1) fetchSteps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workfollowId]);

  // ---- Form ----
  const formik = useFormik({
    initialValues: detail ? detail : DEFAULT_DETAIL,
    enableReinitialize: true,
    validationSchema: Yup.object().shape({
      title: Yup.string().trim().nullable().required("Vui lòng nhập tên tờ trình").max(100, "Độ dài không quá 150 ký tự"),
      code: Yup.string().trim().nullable().required("Vui lòng nhập số tờ trình").max(100, "Độ dài không quá 150 ký tự"),
    }),
    onSubmit: (values, { setSubmitting }) => {
      if (id > 0 && detail && detail.author_id != user.data.id) {
        setSubmitting(false);
        return;
      }
      // ✅ Validate TRƯỚC khi bật loading (khắc phục lỗi kẹt loading của V1).
      if (!values.list_file || values.list_file.length <= 0) {
        alert("Vui lòng chọn file đính kèm");
        setSubmitting(false);
        return;
      }
      let err = "";
      listProgress.forEach((item) => {
        if (!item.list_progress || item.list_progress.length === 0) {
          err += item.title + " chưa có người tham gia. ";
        }
      });
      if (err) {
        alert(err);
        setSubmitting(false);
        return;
      }

      setLoading(true);
      const payloadValues = { ...values, workflow_type: workfollowId };
      if (id > 0 && detail && detail.waiting_position && detail.waiting_position > 0) {
        payloadValues.position = detail.waiting_position;
        payloadValues.waiting_position = 0;
      }
      const payload = { ...payloadValues, workflow_steps_json: JSON.stringify(listProgress) };

      const request =
        id > 0
          ? trinhKyApi.update(user.config, id, payload)
          : trinhKyApi.create(user.config, payload);

      request
        .then((res) => {
          setLoading(false);
          setSubmitting(false);
          if (res.data.status === "success") {
            confirmAlert({
              title: "Thành công",
              message: id > 0 ? "Cập nhật tờ trình thành công" : "Tạo tờ trình thành công",
              buttons: [
                {
                  label: "OK",
                  onClick: () => {
                    if (id > 0) fetchDetail(false);
                    else history.push(ROUTE.edit(res.data.id));
                  },
                },
              ],
            });
          } else {
            confirmAlert({ title: "Lỗi", message: res.data.message || "Có lỗi xảy ra", buttons: [{ label: "OK" }] });
          }
        })
        .catch((error) => {
          setLoading(false);
          setSubmitting(false);
          console.error(error);
          confirmAlert({ title: "Lỗi kết nối", message: "Không thể gửi yêu cầu lên máy chủ", buttons: [{ label: "OK" }] });
        });
    },
  });

  // ---- Thao tác ký ----
  const actionChecked = (stepId, datasave) => {
    setButtonLoading(true);
    trinhKyApi
      .stepAction(user.config, stepId, datasave)
      .then((res) => {
        setUserComment("");
        if (res.data.status === "success") {
          confirmAlert({
            title: "Thông báo",
            message: "Thao tác thành công",
            buttons: [
              {
                label: "OK",
                onClick: () => {
                  setButtonLoading(false);
                  history.push(ROUTE.list);
                },
              },
            ],
          });
        } else {
          setButtonLoading(false);
          confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
        }
      })
      .catch((err) => {
        console.log(err);
        setButtonLoading(false);
      });
  };

  const requireComment = (stepId, action) => {
    if (userComment && userComment !== "") actionChecked(stepId, { action, note_comment: userComment });
    else alert("Vui lòng đưa ra ý kiến");
  };
  const handleApprove = (stepId) => actionChecked(stepId, { action: ACTION.APPROVE, note_comment: userComment });
  const handleApproveQues = (stepId) => requireComment(stepId, ACTION.CONSULT);
  const handleRequestUpdate = (stepId) => requireComment(stepId, ACTION.REQUEST_MORE);
  const giveBack = (stepId) => requireComment(stepId, ACTION.RETURN);
  const handleReject = (stepId) => requireComment(stepId, ACTION.CANCEL);

  // ---- Bình luận + tag ----
  const sendMessage = () => {
    if (myMessage && myMessage !== "") {
      trinhKyApi
        .sendMessage(user.config, { request_id: id, user_id: user.data.id, message: myMessage })
        .then((res) => {
          if (res.data.status === "success") setMyMessage("");
          else confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
        })
        .catch((err) => console.log(err));
    }
  };

  const getUserByTags = (tags) => {
    if (!id) return;
    trinhKyApi
      .searchTags(user.config, id, tags)
      .then((res) => {
        if (res.data.status === "success") {
          setUsersSuggest(res.data.data);
          setShowSuggest(true);
        }
      })
      .catch((e) => console.log(e));
  };

  const onComment = (val) => {
    setMyMessage(val);
    const words = val.split(/\s/);
    const lastWord = words[words.length - 1];
    if (lastWord.startsWith("@")) {
      const keyword = lastWord.substring(1);
      if (keyword.length > 0) {
        setTagKeyword(keyword);
        getUserByTags(keyword);
      } else setShowSuggest(false);
    } else setShowSuggest(false);
  };

  const handleSelectUser = (u) => {
    const words = myMessage.split(/\s/);
    const email = u.email;
    const alias = email.substring(0, email.indexOf("@"));
    words[words.length - 1] = `@${alias}`;
    const newMessage = words.join(" ") + " ";
    setMyMessage(newMessage);
    setShowSuggest(false);
    requestAnimationFrame(() => {
      inputRef.current?.focus();
      const length = newMessage.length;
      inputRef.current?.setSelectionRange(length, length);
    });
  };

  // ---- Thêm / xóa người ký ----
  const addMember = (position, group_name) => {
    setDataNewMember({
      position,
      group_name,
      request_id: id,
      action: 0,
      status: 1,
      user_id: null,
      step_type: 1,
    });
    setModalAddMember(true);
  };

  const actionAddMember = () => {
    setModalAddMember(false);
    const payload = dataNewMember;
    setDataNewMember(null);
    trinhKyApi
      .addStep(user.config, payload)
      .then((res) => {
        if (res.data.status === "success") fetchDetail(false);
        else confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
      })
      .catch((err) => console.log(err));
  };

  const deleteStep = (stepId) => {
    confirmAlert({
      title: "Cảnh báo",
      message: "Bạn muốn xóa vai trò của nhân sự này ra khỏi tờ trình ?",
      buttons: [
        {
          label: "Đồng ý",
          onClick: () => {
            trinhKyApi
              .removeStep(user.config, stepId)
              .then((res) => {
                if (res.data.status === "success") fetchDetail(false);
                else alert(res.data.message);
              })
              .catch((err) => console.log(err));
          },
        },
        { label: "Không" },
      ],
    });
  };

  // Thêm / xóa người ký ở chế độ TẠO MỚI (thao tác trên listProgress cục bộ).
  const extractFullname = (label = "") => {
    if (!label) return "";
    let name = label.split("-")[0].split("(")[0].trim();
    return name.replace(/\s+$/, "");
  };

  const handleAddMember = (progressId) => {
    const u = tempUser[progressId];
    if (!u?.user_id) return;
    setListProgress((prev) =>
      prev.map((p) => {
        if (p.id === progressId) {
          const exists = p.list_progress.some((x) => x.user_id === u.user_id);
          if (exists) return p;
          return {
            ...p,
            list_progress: [
              ...p.list_progress,
              { user_id: u.user_id, user_label: u.user_label, kyphu: 0, list_kyphu: [] },
            ],
          };
        }
        return p;
      })
    );
    setTempUser((prev) => ({ ...prev, [progressId]: { user_id: null, user_label: "" } }));
    setResetKey((prev) => prev + 1);
  };

  const handleRemoveMember = (progressId, userId) => {
    setListProgress((prev) =>
      prev.map((p) =>
        p.id === progressId
          ? { ...p, list_progress: p.list_progress.filter((x) => x.user_id !== userId) }
          : p
      )
    );
  };

  // ---- Hủy tờ trình ----
  const huybototrinh = () => {
    confirmAlert({
      title: "Cảnh báo",
      message: "Bạn muốn Hủy Bỏ tờ trình này ?",
      buttons: [
        {
          label: "Có",
          onClick: () => {
            trinhKyApi
              .cancel(user.config, detail.id)
              .then((res) => {
                if (res.data.status === "success") {
                  confirmAlert({
                    title: "Thông báo",
                    message: "Hủy bỏ thành công",
                    buttons: [{ label: "OK", onClick: () => fetchDetail(false) }],
                  });
                } else {
                  confirmAlert({ title: "Lỗi", message: res.data.message, buttons: [{ label: "OK" }] });
                }
              })
              .catch((err) => console.log(err));
          },
        },
        { label: "Không" },
      ],
    });
  };

  const mavTitle = () => {
    if (id) {
      if (detail) {
        if (detail.status == STATUS.APPROVED) return "Xem tờ trình";
        if (detail.author_id != user.data.id) return "Phê duyệt tờ trình";
        return "Cập nhật tờ trình";
      }
      return "Xem tờ trình";
    }
    return "Thêm mới tờ trình";
  };

  return {
    user,
    loading,
    pageLoading,
    detail,
    listLoaiToTrinh,
    workfollowId,
    setWorkfollowId,
    listProgress,
    setListProgress,
    reloadProgress,
    listMessage,
    userComment,
    setUserComment,
    buttonLoading,
    formik,
    // ký
    handleApprove,
    handleApproveQues,
    handleRequestUpdate,
    giveBack,
    handleReject,
    // bình luận
    myMessage,
    setMyMessage,
    onComment,
    sendMessage,
    usersSuggest,
    showSuggest,
    handleSelectUser,
    inputRef,
    tagKeyword,
    // thành viên
    addMember,
    actionAddMember,
    deleteStep,
    handleAddMember,
    handleRemoveMember,
    extractFullname,
    tempUser,
    setTempUser,
    resetKey,
    dataNewMember,
    setDataNewMember,
    modalAddMember,
    setModalAddMember,
    // hủy
    huybototrinh,
    canCancle,
    roleCancle,
    mavTitle,
  };
}
